import { IAuthService, IHttpService } from "frontend-core";
import { container, injectable } from "tsyringe";
import { AxiosResponse } from "axios";
import { ITabletAuthService } from "@/services/ITabletAuthService";

@injectable()
export class TabletAuthService implements ITabletAuthService{
  private readonly authService: IAuthService = container.resolve(
    "IAuthService",
  );
  private readonly httpService: IHttpService = container.resolve(
    "IHttpService",
  );

  public async loginFromTablet(token: string): Promise<AxiosResponse> {
    const res = await this.httpService.api.post("/lk-auth-from-tablet", { token });
    if (res.data.token) {
      this.authService.credentials = {
        mercureToken: res.data.mercure_token,
        refreshToken: res.data.refresh_token,
        token: res.data.token,
      };
    }
    return res;
  }
}